import { styled } from '@mui/system';
import { Box } from '@mui/material';

const cssGradient =
  'radial-gradient(circle at 10% 15%, rgba(120, 0, 150, 0.03) 10%, transparent 20%),' +
  'radial-gradient(circle at 20% 5%, rgba(120, 0, 150, 0.08), transparent 20%),' +
  'radial-gradient(circle at 30% 75%, rgba(120, 0, 150, 0.03) 10%, transparent 20%),' +
  'radial-gradient(circle at 100% 75%, rgba(120, 0, 150, 0.1) 10%, transparent 20%),' +
  'radial-gradient(circle at 100% 72%, rgba(255, 64, 0, 0.03) , transparent 10%),' +
  'radial-gradient(circle at 100% 73%, rgba(255, 64, 0, 0.08) 3%, transparent 15%),' +
  'radial-gradient(circle at 120% 3%, rgba(120, 0, 150, 0.25) 10%, transparent 20%),' +
  'radial-gradient(circle at 110% 14%, rgba(255, 64, 0, 0.08) 5%, transparent 15%),' +
  'radial-gradient(circle at 80% 40%, rgba(120, 0, 150, 0.03) 10%, transparent 30%),' +
  'radial-gradient(circle at 0% 40%, rgba(120, 0, 150, 0.03) 10%, transparent 20%),' +
  'radial-gradient(circle at 0% 40%, rgba(255, 64, 0, 0.03) 10%, transparent 20%),' +
  '#0C0717';

const BackgroundContainer = styled(Box)({
  position: 'relative',
  paddingTop: 'calc(env(safe-area-inset-top, 0px) + 20px)',
  paddingRight: 'calc(env(safe-area-inset-right, 0px) + 20px)',
  paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 20px)',
  paddingLeft: 'calc(env(safe-area-inset-left, 0px) + 20px)',

  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
  width: '100vw',

  // Default: portrait phone (9:16)
  background: `url('/gamepictures/backgroundphone.webp') center/cover no-repeat, ${cssGradient}`,

  // 4:3 — tablets, squarish screens
  '@media (min-aspect-ratio: 4/3)': {
    background: `url('/gamepictures/backgroundfouronthree.webp') center/cover no-repeat, ${cssGradient}`,
  },

  // 16:9 — landscape phones, widescreen monitors
  '@media (min-aspect-ratio: 16/9)': {
    background: `url('/gamepictures/backgroundsixteenonnine.webp') center/cover no-repeat, ${cssGradient}`,
  },

  color: '#ffffff',
  overflowY: 'auto',
  overflowX: 'hidden',
  boxSizing: 'border-box',
});

export default BackgroundContainer;
